const itemTypes = {
    CARD: 'card',
    DIV: 'div',
};


// Path: board-master\components\Card.js
export default itemTypes;